<div class="account-section">
  <div class="my-section-box">
    @if (true) {
      <form [formGroup]="frictionDrumMaintainanceForm">
        <div class="my-section-box__headline">{{ 'common.airdisc_value_calculator_fleet_drumBrake_title' | cxTranslate
        }}</div>
        <div class="my-section-box fleetInfo" id="fleetInfo">
          <div class="my-section-box-inner">
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="averageMilageToChangeFriction">
                  {{ 'common.airDiscBrake_value_calculator_changeFriction' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="averageMilageToChangeFriction" (keyup)="calculateAndSetSum()" />
                    @if (form.averageMilageToChangeFriction.invalid && (form.averageMilageToChangeFriction.dirty || form.averageMilageToChangeFriction.touched)) {
                      <span class="text-danger-show"
                        >
                      {{'common.form_field_required'|cxTranslate}}</span>
                    }
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                    {{ 'common.value_calculator_fleet_miles' | cxTranslate }}
                    <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_changeFriction',
                                   'common.airDiscBrake_value_calculator_popup_changeFriction')" class="btn-link">
                        <img src="/icons/question_dark_kb.svg" alt="Air Disc friction maintainance Service">
                      </span>
                    </mat-dialog-actions>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 px-0">
                <label class="form-label" for="noOfFrictionReplacementsAtTradeIn">
                  {{ 'common.airDiscBrake_value_calculator_noOfFrictionReplacementsInTradeIn' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="noOfFrictionReplacementsAtTradeIn" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                    {{ 'common.airDiscBrake_value_calculator_replacementCycle' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row  col-12">
              @if (isTractor) {
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="fleetSizeTrailers">
                    {{ 'common.airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn' | cxTranslate }}*
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-10 col-xs-10 col-sm-10 pr-0">
                      <select class="form-control" formControlName="brakeFrictionRequirementAtTradeIn"
                        (change)="calculateAndSetSum()">
                        @for (x of adbDropDownData; track x) {
                          <option [value]="x.code">{{ x.name | cxTranslate}}</option>
                        }
                      </select>
                    </div>
                    <div class="col-2 col-xs-2 col-sm-2 EndaTooltip">
                      <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_brakeFrictionRequirementAtTradeIn',
                                   'common.airDiscBrake_value_calculator_popup_brakeFrictionRequirementAtTradeIn')"
                          class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="Air Disc friction maintainance Service">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
              }
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="noOfDrumReplacementsAtTradeIn">
                  {{ 'common.airDiscBrake_value_calculator_numberOfDrumReplacementsAtTradeIn' | cxTranslate }}
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="noOfDrumReplacementsAtTradeIn" readonly />
                  </div>
                  <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                    {{ 'common.airDiscBrake_value_calculator_replacementCycle' | cxTranslate }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row col-12">
              <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                <label class="form-label" for="drumBreakShoeReplacementUnitCost">
                  {{ 'common.airDiscBrake_value_calculator_drumBrakeShoeReplacementUnitCost' | cxTranslate }}*
                </label>
                <div class="col-12 px-0 row">
                  <div class="col-8 col-xs-8 col-sm-6 pr-0">
                    <input type="text" formControlName="drumBreakShoeReplacementUnitCost" (keyup)="calculateAndSetSum()"
                      appNumberFormat />
                      @if (form.drumBreakShoeReplacementUnitCost.invalid && (form.drumBreakShoeReplacementUnitCost.dirty || form.drumBreakShoeReplacementUnitCost.touched)) {
                        <span class="text-danger-show"
                          >
                        {{'common.form_field_required'|cxTranslate}}</span>
                      }
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                      {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                      <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_drumBrakeShoeReplacementUnitCost',
                                   'common.airDiscBrake_value_calculator_popup_drumBrakeShoeReplacementUnitCost')"
                          class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="Air Disc friction maintainance Service">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="drumBreakReplacementUnitCost">
                    {{ 'common.airDiscBrake_value_calculator_drumBrakeReplacementUnitCost' | cxTranslate }}
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-8 col-xs-8 col-sm-6 pr-0">
                      <input type="text" appNumberFormat formControlName="drumBreakReplacementUnitCost" readonly />
                    </div>
                    <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                      {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                      <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_drumBrakeReplacementUnitCost',
                                   'common.airDiscBrake_value_calculator_popup_drumBrakeReplacementUnitCost')"
                          class="btn-link">
                          <img src="/icons/question_dark_kb.svg" alt="Air Disc friction maintainance Service">
                        </span>
                      </mat-dialog-actions>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row  col-12">
                <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                  <label class="form-label" for="drumReplacementUnitCost">
                    {{ 'common.airDiscBrake_value_calculator_drumReplacementUnitCost' | cxTranslate }}*
                  </label>
                  <div class="col-12 px-0 row">
                    <div class="col-8 col-xs-8 col-sm-6 pr-0">
                      <input type="text" formControlName="drumReplacementUnitCost" appNumberFormat
                        (keyup)="calculateAndSetSum()" />
                        @if (form.drumReplacementUnitCost.invalid && (form.drumReplacementUnitCost.dirty || form.drumReplacementUnitCost.touched)) {
                          <span class="text-danger-show"
                            >
                          {{'common.form_field_required'|cxTranslate}}</span>
                        }
                      </div>
                      <div class="col-4 col-xs-4 col-sm-5 EndaTooltip">
                        {{ 'common.airDiscBrake_value_calculator_usd_unit' | cxTranslate }}
                        <mat-dialog-actions>
                      <span (click)="airdiskService.openTootlip(
                                  'common.airDiscBrake_value_calculator_drumReplacementUnitCost',
                                   'common.airDiscBrake_value_calculator_popup_drumReplacementUnitCost')"
                            class="btn-link">
                            <img src="/icons/question_dark_kb.svg" alt="Air Disc friction maintainance Service">
                          </span>
                        </mat-dialog-actions>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 px-0">
                    <label class="form-label" for="drumBreakReplacementFleetCost">
                      {{ 'common.airDiscBrake_value_calculator_drumbrakeReplacementFleetCost' | cxTranslate }}
                    </label>
                    <div class="col-12 px-0 row">
                      <div class="col-8 col-xs-8 col-sm-6 pr-0">
                        <input type="text" formControlName="drumBreakReplacementFleetCost" readonly />
                      </div>
                      <div class="col-4 col-xs-4 col-sm-5 EnduTooltip">
                        {{ 'common.text_smartire_usd' | cxTranslate }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="airdisk-button-block">
                  <button type="button" class="btn btn-primary endaSureBack visitorInfoNext yellow-btn"
                    (click)="endaSureBack()"><img src="/icons/link-right-white.svg" class="right-arrow"
                    alt="Air Disc friction maintainance Service Back">
                  {{ 'common.value_calculator_back_button' | cxTranslate }}</button>
                  <button type="button" class="btn btn-primary endaSureNxt visitorInfoNext yellow-btn"
                    (click)="endaSureNxt()">{{ 'common.value_calculator_next_button' | cxTranslate }}
                    <img src="/icons/link-right-white.svg" class="right-arrow"
                    alt="Air Disc friction maintainance Service Next"></button>
                  </div>
                </div>
              </div>
            </form>
          }
        </div>
      </div>